import React from 'react';
import { alerts } from '@zipdrug/react-api-sdk';
import { alertOnError } from '@zipdrug/ui';
import { graphql } from '@apollo/client/react/hoc';
import withRefreshPatients from './withRefreshPatients';

export default Component => {
  const WithMutation = graphql(alerts.mutateUpdateAlert, { name: 'mutateUpdateAlert' })(Component);
  const WithRefresh = withRefreshPatients(WithMutation);
  
  return React.forwardRef((props, ref) => {
    const mutateUpdateAlert = variables =>
      alertOnError(props.mutateUpdateAlert({ variables }))
        // refresh the alert counts
        .then(props.onRefetchPatients);
    
    return <WithRefresh {...props} mutateUpdateAlert={mutateUpdateAlert} ref={ref} />;
  });
};
